import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            component: () => import( /* webpackChunkName: "home" */ './views/Home.vue'),
        },
        {
            path: '/hall-of-glory-egp',
            name: 'hall-of-glory-egp',
            component: () => import( /* webpackChunkName: "hall-of-glory-egp" */ './views/Hall-of-glory-egp.vue'),
        },
        {
            path: '/catalogue-awards',
            name: 'catalogue-awards',
            component: () => import( /* webpackChunkName: "catalogue-awards" */ './views/Catalogue-awards'),
        },
        {
            path: '/power-yuri-grom',
            name: 'power-yuri-grom',
            component: () => import( /* webpackChunkName: "power-yuri-grom" */ './views/Power-yuri-grom')
        },
        {
            path: '/thunderer',
            name: 'thunderer',
            component: () => import( /* webpackChunkName: "thunderer" */ './views/Thunderer')
        },
        {
            path: '/fraction-eg-union',
            name: 'fraction-eg-union',
            component: () => import( /* webpackChunkName: "fraction-eg-union" */ './views/Fraction-eg-union'),
        },
        {
            path: '/euryale-chronicles',
            name: 'euryale-chronicles',
            component: () => import( /* webpackChunkName: "euryale-chronicles" */ './views/Euryale-chronicles'),
        },
        {
            path: '/ax-corps',
            name: 'ax-corps',
            component: () => import( /* webpackChunkName: "ax-corps" */ './views/AX-corps')
        },
        {
            path: '*',
            name: '404',
            component: () => import( /* webpackChunkName: "404" */ './views/404.vue')
        }
    ]
})